// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3NbBl","buttons":"Footer_buttons__WcdOg"};